<div [@routerTransition]>
    <sub-header
        [title]="('Locations' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"
    ></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <tabset>
                    <tab heading="{{ 'BasicInformation' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="form-group m-form__group">
                                    <label for="CompanyName">{{ l('Company') }}</label>
                                    <select
                                        name="location.companyId"
                                        [(ngModel)]="location.companyId"
                                        class="form-select"
                                    >
                                        <option value="">{{ l('SelectACompany') }}</option>

                                        <option *ngFor="let item of allCompanys" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Location_Code">{{ l('Code') }} *</label>
                                    <input
                                        type="text"
                                        #Location_Code="ngModel"
                                        id="Location_Code"
                                        class="form-control"
                                        [(ngModel)]="location.code"
                                        name="Code"
                                        minlength="0"
                                        maxlength="50"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Location_Code"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Location_Name">{{ l('Name') }} *</label>
                                    <input
                                        type="text"
                                        #Location_Name="ngModel"
                                        id="Location_Name"
                                        class="form-control"
                                        [(ngModel)]="location.name"
                                        name="Name"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Location_Name"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <br>
                                <label class="form-check form-check-custom form-check-solid">
                                    <input
                                        id="Location_AutoAcceptStockTransfer"
                                        #Location_AutoAcceptStockTransfer="ngModel"
                                        name="AutoAcceptStockTransfer"
                                        [(ngModel)]="location.autoAcceptStockTransfer"
                                        type="checkbox"
                                        class="form-check-input"
                                    />
                                    <span class="form-check-label">
                                        {{ l('AutoAcceptStockTransfer') }}
                                    </span>
                                </label>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Location_Remarks">{{ l('Remarks') }}</label>
                                    <input
                                        type="text"
                                        #Location_Remarks="ngModel"
                                        id="Location_Remarks"
                                        class="form-control"
                                        [(ngModel)]="location.remarks"
                                        name="Remarks"
                                    />
                                    <validation-messages [formCtrl]="Location_Remarks"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Website">{{ l('Website') }}</label>
                                    <input
                                        type="text"
                                        #Location_Website="ngModel"
                                        id="Location_Website"
                                        class="form-control"
                                        [(ngModel)]="location.website"
                                        name="Website"
                                    />
                                    <validation-messages [formCtrl]="Location_Website"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Email">{{ l('Email') }}</label>
                                    <input
                                        type="text"
                                        #Location_Email="ngModel"
                                        id="Location_Email"
                                        class="form-control"
                                        [(ngModel)]="location.email"
                                        name="Email"
                                    />
                                    <validation-messages [formCtrl]="Location_Email"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Address' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Address1">{{ l('Address1') }}</label>
                                    <input
                                        type="text"
                                        #Location_Address1="ngModel"
                                        id="Location_Address1"
                                        class="form-control"
                                        [(ngModel)]="location.address1"
                                        name="Address1"
                                    />
                                    <validation-messages [formCtrl]="Location_Address1"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Address2">{{ l('Address2') }}</label>
                                    <input
                                        type="text"
                                        #Location_Address2="ngModel"
                                        id="Location_Address2"
                                        class="form-control"
                                        [(ngModel)]="location.address2"
                                        name="Address2"
                                    />
                                    <validation-messages [formCtrl]="Location_Address2"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Address3">{{ l('Address3') }}</label>
                                    <input
                                        type="text"
                                        #Location_Address3="ngModel"
                                        id="Location_Address3"
                                        class="form-control"
                                        [(ngModel)]="location.address3"
                                        name="Address3"
                                    />
                                    <validation-messages [formCtrl]="Location_Address3"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_City">{{ l('City') }}</label>
                                    <input
                                        type="text"
                                        #Location_City="ngModel"
                                        id="Location_City"
                                        class="form-control"
                                        [(ngModel)]="location.city"
                                        name="City"
                                    />
                                    <validation-messages [formCtrl]="Location_City"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_State">{{ l('State') }}</label>
                                    <input
                                        type="text"
                                        #Location_State="ngModel"
                                        id="Location_State"
                                        class="form-control"
                                        [(ngModel)]="location.state"
                                        name="State"
                                    />
                                    <validation-messages [formCtrl]="Location_State"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Country">{{ l('Country') }}</label>
                                    <input
                                        type="text"
                                        #Location_Country="ngModel"
                                        id="Location_Country"
                                        class="form-control"
                                        [(ngModel)]="location.country"
                                        name="Country"
                                    />
                                    <validation-messages [formCtrl]="Location_Country"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_PostalCode">{{ l('PostalCode') }}</label>
                                    <input
                                        type="text"
                                        #Location_PostalCode="ngModel"
                                        id="Location_PostalCode"
                                        class="form-control"
                                        [(ngModel)]="location.postalCode"
                                        name="PostalCode"
                                    />
                                    <validation-messages [formCtrl]="Location_PostalCode"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Contact' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Phone">{{ l('Phone') }}</label>
                                    <input
                                        type="text"
                                        #Location_Phone="ngModel"
                                        id="Location_Phone"
                                        class="form-control"
                                        [(ngModel)]="location.phone"
                                        name="Phone"
                                    />
                                    <validation-messages [formCtrl]="Location_Phone"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Location_Fax">{{ l('Fax') }}</label>
                                    <input
                                        type="text"
                                        #Location_Fax="ngModel"
                                        id="Location_Fax"
                                        class="form-control"
                                        [(ngModel)]="location.fax"
                                        name="Fax"
                                    />
                                    <validation-messages [formCtrl]="Location_Fax"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button
                        (click)="save()"
                        class="btn btn-primary blue me-2"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button
                        *ngIf="!this.location.id"
                        (click)="saveAndNew()"
                        class="btn btn-primary blue"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndNew') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
